<template>
  <div class="toast" v-if="error">
    <img src="./../assets/warning.png" alt="" srcset="" />
    <p class="warning-tips">
      {{ errorText }}
    </p>
  </div>
  <div class="sub-header">
    <img src="./../assets/cupshe.png" alt="" />
  </div>
  <div class="sub-content">
    <img class="m-banner" src="./../assets/sub_bg_m.png" alt="" />
    <div v-if="success">
      <div class="sub-box">
        <img class="success-icon" src="./../assets/success_icon.png" alt="" />
        <p class="box-title success-tips">
          {{ $t("subscribe4") }}
        </p>
      </div>
    </div>
    <div v-else>
      <div class="sub-box">
        <p class="box-title">
          {{ $t("subscribe1") }}
        </p>
        <p class="box-tips">{{ $t("subscribe2") }}</p>
        <div class="box-button" @click="submit">{{ $t("subscribe3") }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { useI18n } from "vue-i18n";
import qs from "query-string";
import { defineComponent, reactive, toRefs, watch, onMounted } from "vue";
import { quickRegister } from "./../service/ums";
export default defineComponent({
  setup() {
    const { t } = useI18n();
    const state = reactive({
      t,
      success: false,
      error: false,
      errorText: "",
      submit: async () => {
        const href = location.href.split("?")[1];
        const query = qs.parse(href);
        const { data } = await quickRegister({
          userId: query.userId,
          subscribeWay: 1,
          newsLetter: 1,
          triggerMode: 0,
          subscribeFrom: 3,
        });
        if (!data.success) {
          if (data.retCode === "1000001") {
            state.errorText = t("You're already on the list!");
            state.error = true;
            return;
          } else {
            state.errorText = t("Oops, there was a hiccup!Please try again.");
            state.error = true;
            return;
          }
        } else {
          state.success = true;
          return;
        }
      },
      unSubscribe: async () => {
        const href = location.href.split("?")[1];
        const query = qs.parse(href);
        await quickRegister({
          userId: query.userId,
          subscribeWay: 1,
          newsLetter: 0,
          triggerMode: 0,
          subscribeFrom: 3,
        });
      },
    });
    onMounted(() => {
      state.unSubscribe();
    });
    watch(
      () => state.error,
      (newVal) => {
        if (newVal) {
          setTimeout(() => {
            state.error = false;
          }, 2000);
        }
      }
    );
    return {
      ...toRefs(state),
    };
  },
});
</script>
<style lang="less" scoped>
p {
  margin: 0;
}
@media (max-width: 768px) {
  .toast {
    position: fixed;
    top: 43%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 260px;
    height: 114px;
    padding: 16px;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    img {
      width: 40px;
      height: auto;
      margin-bottom: 12px;
    }
    .warning-tips {
      text-align: center;
      font-family: "Avenir Next LT Pro 400";
      font-size: 12px;
      line-height: 14px;
      color: #ffffff;
    }
  }
  .sub-header {
    text-align: center;
    img {
      height: 45px;
      margin-top: 6px;
      margin-bottom: 8px;
    }
  }
  .sub-content {
    .m-banner {
      width: 100%;
    }
  }
  .sub-box {
    margin-top: 40px;
    padding: 0 24px;
    text-align: center;
    .success-icon {
      width: 60px;
      height: auto;
      margin-bottom: 24px;
    }
    .success-tips {
      color: #00b45a !important;
    }
    .box-title {
      font-family: "Avenir Next LT Pro 500";
      font-size: 14px;
      line-height: 21px;
      text-align: center;
      margin-bottom: 40px;
      color: #1f1f1f;
    }
    .box-tips {
      color: #1f1f1f;
      text-align: center;
      font-family: "Avenir Next LT Pro 400";
      font-size: 14px;
      line-height: 21px;
      margin-bottom: 24px;
    }
    .box-button {
      text-align: center;
      box-sizing: border-box;
      width: 260px;
      padding: 15px 20px;
      text-align: center;
      margin: 0 auto;
      background-color: #000;
      color: #ffffff;
      letter-spacing: 1px;
      font-family: "Avenir Next LT Pro 800";
    }
  }
}
@media (min-width: 768px) {
  .m-banner {
    display: none;
  }
  .toast {
    position: fixed;
    top: 59%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 260px;
    height: 114px;
    padding: 16px;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    img {
      width: 40px;
      height: auto;
      margin-bottom: 12px;
    }
    .warning-tips {
      text-align: center;
      font-family: "Avenir Next LT Pro 400";
      font-size: 12px;
      line-height: 14px;
      color: #ffffff;
    }
  }
  .sub-header {
    background-color: #ffffff;
    text-align: center;
    img {
      padding-top: 16px;
      padding-bottom: 20px;
      height: 62px;
    }
  }
  .sub-content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: calc(100vh - 101px);
    background: url(./../assets/sub_bg_pc.jpeg) no-repeat;
    background-size: cover;
    background-position: center;
    .sub-box {
      width: 580px;
      height: 340px;
      padding: 60px 30px 68px 30px;
      background-color: #ffffff;
      box-sizing: border-box;
      text-align: center;

      .success-icon {
        width: 60px;
        padding-top: 20px;
        margin-bottom: 32px;
      }

      .success-tips {
        color: #00b45a !important;
      }
      .box-title {
        font-family: "Avenir Next LT Pro 500";
        font-size: 18px;
        color: #1f1f1f;
        text-align: center;
        line-height: 30px;
        margin-bottom: 60px;
        text-transform: capitalize;
      }
      .box-tips {
        font-family: "Avenir Next LT Pro 500";
        font-size: 18px;
        color: rgba(102, 102, 102, 1);
        text-align: center;
        line-height: 20px;
        margin-bottom: 24px;
        text-transform: capitalize;
      }
      .box-button {
        font-family: "Avenir Next LT Pro 800";
        font-size: 14px;
        color: #ffffff;
        text-align: center;
        background-color: #000;
        width: 260px;
        padding: 16px 0px;
        display: inline-block;
        letter-spacing: 1px;
        cursor: pointer;
      }
    }
  }
}
</style>
